module.exports = __webpack_public_path__ + "img/section07-img03.6dee827e.png";